import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Http } from "@angular/http";
import { ServiceOffersService } from "../../_services/serviceoffers.service";
import { AgreementsService } from "../../_services/agreements.service";
import { StatisticsService } from "../../_services/statistics.service";
import { ServiceAddonsService } from "../../_services/serviceaddons.service";
import { Agreement } from "../../_models/agreement";
import { ServiceOffer } from "../../_models/serviceoffer";
import { ServiceAddon } from "../../_models/serviceaddon";
import { StatisticEvent } from "../../_models/statisticevent";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from "rxjs";
import {
  ToasterModule,
  ToasterService,
  ToasterConfig,
} from "angular2-toaster/angular2-toaster";
import { Car } from "../../_models/car";
import { DealersService } from "../../_services/dealers.service";
import { Dealer } from "../../_models/dealer";
import { CarsService } from "../../_services/cars.service";
import { orderBy, sortBy } from "lodash";

@Component({
  selector: "app-dealerservicecalculator",
  templateUrl: "./dealerservicecalculator.component.html",
  providers: [
    ServiceOffersService,
    ServiceAddonsService,
    AgreementsService,
    StatisticsService,
    CarsService,
    DealersService,
  ],
})
export class DealerServiceCalculatorComponent implements OnInit {
  private serviceoffers: ServiceOffer[];
  private serviceaddons: ServiceAddon[];
  private car: any;
  public dealer: Dealer = new Dealer();
  private statisticsService: StatisticsService;
  public hasResponded: boolean = false;

  private carid: string = "";
  private dealerId: string = "";
  private errorMessage: string = "";
  private isLoading: boolean = true;
  private calcStartupCost: boolean = true;

  public kmSelected: number = 15000;
  public yearSelected: number = 5;
  public optin: boolean = true;
  public calculatedPrice: number;
  private serviceaddonslist = [];
  private carname: string = "";
  private payment_method: string = "";
  public startupPrice: number = 0;
  public agree: Agreement;
  private subscription: Subscription;
  private service_price: number;
  private monthOld: number;
  private monthsToGo: number;
  public dealerSA: string = ""; //"Serviceaftale" nameing frontend

  public options: any = {
    yearStep: [],
    kmStep: [],
  };

  private toasterService: ToasterService;

  public toasterconfig: ToasterConfig = new ToasterConfig({
    tapToDismiss: true,
    timeout: 5000,
  });

  constructor(
    toasterService: ToasterService,
    statisticsService: StatisticsService,
    private agreementsService: AgreementsService,
    private carService: CarsService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private serviceAddonsService: ServiceAddonsService,
    private serviceoffersService: ServiceOffersService,
    private dealersService: DealersService,
    private modalService: NgbModal
  ) {
    this.toasterService = toasterService;
    this.statisticsService = statisticsService;
  }

  ngOnInit() {
    this.isLoading = true;
    this.dealerSA = "Serviceabonnement";

    setInterval(function () {
      window.top.postMessage(document.body.scrollHeight, "*");
    }, 500);

    // subscribe to router event
    this.subscription = this.activatedRoute.queryParams.subscribe(
      (param: any) => {
        this.carid = param["id"];
        this.monthOld = param["monthOldSelected"];

        this.carService.get(this.carid).subscribe(
          (p) => (this.car = p),
          (e) => (this.errorMessage = e),
          () => {
            this.dealerId = this.car.dealer_id;

            this.dealersService.get(this.dealerId).subscribe((p) => {
              this.dealer = p;

              //Check if dealer is stsbiler
              if (this.dealer._id == "63591e878c577855251e44b4") {
                this.dealerSA = "Serviceaftale";
              }

              this.payment_method = this.dealer.payment_method;
              console.log(this.payment_method + " this.payment_method");

              this.carname =
                this.car.carmake +
                " " +
                this.car.carmodel +
                " " +
                this.car.carversion;

              // subscribe to router event
              this.serviceoffersService.getByCar(this.car._id).subscribe(
                (p) => (this.serviceoffers = p),
                (e) => (this.errorMessage = e),
                () => {
                  for (var i = 0; i < this.serviceoffers.length; ++i) {
                    let singleOffer: ServiceOffer = this.serviceoffers[i];
                    let year: number = singleOffer.years;
                    let km: number = singleOffer.km / singleOffer.years;

                    if (!(this.options.yearStep.indexOf(year) > -1)) {
                      this.options.yearStep.push(year);
                    }
                    if (!(this.options.kmStep.indexOf(km) > -1)) {
                      this.options.kmStep.push(km);
                    }
                  }
                  this.options.yearStep.sort(function (a, b) {
                    return a - b;
                  });
                  this.options.kmStep.sort(function (a, b) {
                    return a - b;
                  });

                  this.serviceAddonsService
                    .getDealer(this.dealer._id, "guarantee")
                    .subscribe(
                      (p) => (this.serviceaddons = p),
                      (e) => (this.errorMessage = e),
                      () => {
                        for (var i = 0; i < this.serviceaddons.length; i++) {
                          this.serviceaddons[i].selected = false;
                        }
                        this.calculatePrice();
                        this.isLoading = false;
                      }
                    );
                }
              );
            });
          }
        );
      }
    );
  }

  updatePrice() {
    this.calculatePrice();
  }

  calculatePrice() {
    //Set years to 10 if dealer is Sondrup Service Aftaler
    if (this.dealerId == "63510bb88c577855251e357e") {
      this.yearSelected = 10;
    }

    let years: number = this.yearSelected;
    let totalKM: number = this.yearSelected * this.kmSelected;
    let result: ServiceOffer;

    result = this.serviceoffers.find(function (offer: ServiceOffer) {
      return offer.years == years && offer.km == totalKM;
    });

    if (result != undefined) {
      this.service_price = result.price;

      //let monthsPassed = this.monthDiff(new Date(),new Date());
      let monthsPassed = this.monthOld;

      if (this.payment_method == "split") {
        let newPrice: number;
        newPrice = result.price;

        if (this.calcStartupCost) {
          this.monthsToGo = years * 12 - monthsPassed;
          newPrice = Math.ceil((result.price * (years * 12)) / this.monthsToGo);
        }

        this.serviceaddonslist = [];
        for (var i = 0; i < this.serviceaddons.length; i++) {
          if (this.serviceaddons[i].selected) {
            newPrice += this.serviceaddons[i].price;
            this.serviceaddonslist.push(this.serviceaddons[i]);
          }
        }

        this.calculatedPrice = newPrice;
      } else if (this.payment_method == "up_front") {
        let newPrice: number;

        newPrice = result.price * monthsPassed;
        this.startupPrice = newPrice;
        newPrice = result.price;
        this.serviceaddonslist = [];
        for (var i = 0; i < this.serviceaddons.length; i++) {
          if (this.serviceaddons[i].selected) {
            newPrice += this.serviceaddons[i].price;
            this.serviceaddonslist.push(this.serviceaddons[i]);
          }
        }

        this.calculatedPrice = newPrice;
      }
    } else {
      // Don't show error toast if dealer is Sondrup Service Aftaler (63510bb88c577855251e357e)

      if (this.dealerId !== "63510bb88c577855251e357e") {
        this.toasterService.pop(
          "error",
          "Error !!",
          "Kombinationen blev ikke fundet, kontakt venligst forhandleren"
        );
        this.kmSelected = Math.min.apply(Math, this.options.kmStep);
        this.yearSelected = Math.max.apply(Math, this.options.yearStep);
        this.updatePrice();
      }
    }
  }

  monthDiff(d1, d2): number {
    // var months;
    // months = (d2.getFullYear() - d1.getFullYear()) * 12;
    // months -= d1.getMonth() + 1;
    // months += d2.getMonth();
    // return months <= 0 ? 0 : months;
    return this.getMonthsBetween(d1, d2, false);
  }

  getMonthsBetween(date1, date2, roundUpFractionalMonths) {
    //Months will be calculated between start and end dates.
    //Make sure start date is less than end date.
    //But remember if the difference should be negative.
    var startDate = date1;
    var endDate = date2;
    var inverse = false;
    if (date1 > date2) {
      startDate = date2;
      endDate = date1;
      inverse = true;
    }

    //Calculate the differences between the start and end dates
    var yearsDifference = endDate.getFullYear() - startDate.getFullYear();
    var monthsDifference = endDate.getMonth() - startDate.getMonth();
    var daysDifference = endDate.getDate() - startDate.getDate();

    var monthCorrection = 0;
    //If roundUpFractionalMonths is true, check if an extra month needs to be added from rounding up.
    //The difference is done by ceiling (round up), e.g. 3 months and 1 day will be 4 months.
    if (roundUpFractionalMonths === true && daysDifference > 0) {
      monthCorrection = 1;
    }
    //If the day difference between the 2 months is negative, the last month is not a whole month.
    else if (roundUpFractionalMonths !== true && daysDifference < 0) {
      monthCorrection = -1;
    }

    return (
      (inverse ? -1 : 1) *
      (yearsDifference * 12 + monthsDifference + monthCorrection)
    );
  }

  ngOnDestroy() {
    // prevent memory leak by unsubscribing
    this.subscription.unsubscribe();
  }
  gotoCheckout(): void {
    let newItem: Partial<Agreement> = {};
    newItem.car = this.car;
    newItem.years = this.yearSelected + "";
    newItem.km = this.kmSelected + "";
    newItem.addons = this.serviceaddonslist;
    newItem.price = this.calculatedPrice;
    newItem.service_price = this.service_price;
    newItem.payout = this.startupPrice;
    newItem.monthsToGo = this.monthsToGo;
    newItem.carMonthsOld = this.monthOld;

    sessionStorage.setItem("agree", JSON.stringify(newItem));
    this.router.navigate(["/dealercheckout/" + this.carid]);
    // top.window.location.href='/#/dealercheckout/'+this.carid;
  }
}



// WEBPACK FOOTER //
// ./src/app/landingpages/dealerservicecalculator/dealerservicecalculator.component.ts